import { format } from 'date-fns';
import { useMobile } from '../../../../../../../common/services/screenSize/ScreenSizeService';
import { Header, ListContainer, Text } from './DentalPricingTooltip.styles';

interface Props {
  readonly isVerified: boolean;
  readonly importedAt?: Date;
}

export const DentalPricingTooltip = ({ isVerified, importedAt }: Props) => {
  const isMobile = useMobile();

  return (
    <>
      {isMobile && <Header>Check-up and clean</Header>}
      {!isVerified && (
        <Text>
          HealthEngine collected this pricing in{' '}
          {importedAt ? format(importedAt, 'LLLL yyyy') : 'May to August 2020'} and it has not been
          verified by the practice.
        </Text>
      )}
      <Text>
        This price range is based on the price of the following standard treatments (before
        insurance rebate):
      </Text>
      <ListContainer>
        <li>comprehensive oral examination (item 011)</li>
        <li>removal of calculus - first visit (item 114)</li>
      </ListContainer>
      <Text>
        The price may vary, e.g. if you are offered different or additional treatments such as
        Xrays, fluoride treatment
      </Text>
    </>
  );
};
